import APIRequest from "../utils/APIRequest";

export default class BookingTypeModel {

    static getByDoctorId = async(doctorID)=>{
        return await APIRequest.set(`v1/bookingtype/doctor/`+doctorID, 'GET');
    }

}
